var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"content",style:(`${_vm.$attrs.column.style ? _vm.$attrs.column.style : ''} ${_vm.data['style']}`),attrs:{"title":`${_vm.data[_vm.$attrs.column.key]}${_vm.data['error'] != null ? '\nErrors:\n' + _vm.data['error'] : ''}`},domProps:{"innerHTML":_vm._s(_vm.data[_vm.$attrs.column.key])}})
}
var staticRenderFns = []

export { render, staticRenderFns }